import Api from 'api'

const config = {
  baseURL: '/api/app/v1/referral',
}
const api = new Api(config)

api.fetchLinks = ({ ...rest }) => api.get('/referral-links', { ...rest })
api.createLink = ({ ...rest }) => api.post('/referral-links', { ...rest })
api.updateLink = ({ id, ...rest }) =>
  api.patch(`/referral-links/${id}`, { ...rest })
api.fetchLink = ({ id, ...rest }) =>
  api.get(`/referral-links/${id}`, { ...rest })
api.fetchFinancialTerms = () => api.get(`/financial-terms`)
api.fetchClients = ({ ...rest }) => api.get('/referral-clients', { ...rest })
api.updateClient = ({ id, ...rest }) =>
  api.patch(`/referral-clients/${id}`, { ...rest })

export default api
